<ng-container *transloco="let t;">
    <div class="auth-wrapper auth-v2">



        <div class="auth-inner row m-0">
            <!-- Brand logo-->
            <a class="brand-logo mobile-adjustment" href="javascript:void(0);">
                <picture>
                    <source srcset="assets/images/logo/simplesignSquareIcon.svg" media="(max-width: 991px)"
                        class="brand-logo-image">
                    <img src="{{logoImageUrl}}" alt="brand-logo" class="brand-logo-image" />
                </picture>
            </a>
            <!-- /Brand logo-->

            <!-- Register-->
            <div class="d-flex col-lg-6 align-items-center auth-bg px-2 p-lg-5">
                <div class="col-12 col-sm-8 col-md-4 col-lg-5 px-xl-2 mx-auto"
                    [class.forgot-password-content]="isForgotPasswordPage">
                    <ng-content></ng-content>
                </div>
            </div>
            <!-- /Register-->
            <!-- Left Text-->
            <div class="d-none d-lg-flex col-lg-6 align-items-center p-5">
                <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                    <img *ngIf="imageUrl" class="img-fluid login-image" [src]="imageUrl" [alt]="imageUrlAlt" />
                </div>
            </div>
            <!-- /Left Text-->
        </div>
    </div>
</ng-container>